import { ArtworkDisplayFetchWrapper, Pane } from '@sheridan-prize/ui';
import { createFileRoute } from '@tanstack/react-router';
import { ArtworkHeader } from '../components/ArtworkHeader';

export const Route = createFileRoute('/view-artwork_/$artworkId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { artworkId } = Route.useParams();

  return (
    <>
      <ArtworkHeader />
      <div className="app">
        <Pane tag="main" classes={'sp-main sp-wide'}>
          <ArtworkDisplayFetchWrapper artworkId={artworkId} />
        </Pane>
      </div>
    </>
  );
}
